import {ChangeDetectorRef, Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LookupModel} from '../../api/models/lookup-model';
import {MatDialog} from '@angular/material/dialog';
import {LookupService} from '../../api/services/lookup.service';
import {NotificationService} from '../../notification/notification.service';
import {maxDateRange} from '../../core/validators/max-date-range.validator';
import {MatConfirmDialogComponent} from '../../dialogs/mat-confirm/mat-confirm-dialog.component';
import {LocalPbxService} from '../local-pbx.service';
import {HolidayGreetingsModel} from '../../api/models/holiday-greetings-model';
import {CloudFileModel} from '../../api/models/cloud-file-model';
import {HolidayGreetingIvrHolidayModel} from '../../api/models/holiday-greeting-ivr-holiday-model';
import {HolidayGreetingsEditRecordingDialogComponent} from './holiday-greetings-edit-recording-dialog.component';
import {dateRangeOverlap} from '../../core/validators/date-range-overlap.validator';
import {DateUtils} from '../../core/utilities/date-time-helpers';
import {CurrentUser} from '../../api/models/current-user';
import * as _ from 'lodash';
import {Dictionary} from 'lodash';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { NgIf, NgFor } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSimpleSelectComponent } from '../../editors/mat-simple-select/mat-simple-select.component';
import { MatLabel, MatError } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout';
import { MatDatetimeInputComponent } from '../../editors/mat-datetime-input/mat-datetime-input.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { AudioControlComponent } from '../../core/visual/audio-control/audio-control.component';

@Component({
    selector: 'app-pbx-holiday-greetings-edit',
    templateUrl: './holiday-greetings-edit.component.html',
    styleUrls: ['./holiday-greetings-edit.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatCard,
        MatCardTitle,
        NgIf,
        MatCardContent,
        MatProgressSpinner,
        MatSimpleSelectComponent,
        MatLabel,
        FlexModule,
        NgFor,
        MatDatetimeInputComponent,
        MatButton,
        MatTooltip,
        MatIcon,
        MatError,
        MatIconButton,
        MatCardActions,
        Angular2PromiseButtonModule,
        AudioControlComponent,
    ],
})
export class HolidayGreetingsEditComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  form: UntypedFormGroup;
  mailboxAccountControl = new UntypedFormControl('', []);

  submitted: boolean;
  serverError: boolean;
  availablePbxAccounts: LookupModel[] = [];
  availablePbxExtensions: LookupModel[] = [];
  availableHolidayGreetings: CloudFileModel[] = [];

  editModel: HolidayGreetingsModel = {
    account: '',
    mailboxAccount: '',
    accountType: undefined,
    holidayList: []
  };

  currentAudioSource: string;
  currentAudioDownloadSource: string;

  isLoading = true;
  buttonSubmitPromise: Promise<void>;
  paramsSubscription;
  account: string;
  hasSupportAccess = false;
  availableHolidayGreetingsGrouped: Dictionary<CloudFileModel[]>;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              public dialog: MatDialog,
              public pbxService: LocalPbxService,
              private lookupService: LookupService,
              private fb: UntypedFormBuilder,
              private readonly changeDetectorRef: ChangeDetectorRef,
              private notificationService: NotificationService) {
    super(route, headerService, titleService, authService);

    this.paramsSubscription = this.route.params.subscribe(params => {
      this.account = params['account'];
      console.log(this.account);
    });

    this.editRoles = [RolesEnum.PbxHolidayGreetings_Edit, RolesEnum.PbxHolidayGreetings_Delete];
    this.deleteRoles = [RolesEnum.PbxHolidayGreetings_Delete];

    this.headerService.showBackButton(true);

    this.createForm();
  }

  onCurrentUserChanged(user?: CurrentUser) {
    super.onCurrentUserChanged(user);

    if (user) {
      this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);
    } else {
      this.hasSupportAccess = false;
    }
  }

  createForm(): void {
    this.form = this.fb.group({
        'mailboxAccount': this.mailboxAccountControl,
        'holidayList': this.fb.array([], dateRangeOverlap('startDate', 'endDate')),
      },
    );
  }

  get holidayFormArray(): UntypedFormArray {
    return this.form.get('holidayList') as UntypedFormArray;
  }

  setHolidayList(holidayList: HolidayGreetingIvrHolidayModel[]) {
    holidayList.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
    const holidaysFormGroups = holidayList.map(item => this.fb.group({
        'id': [item.id],
        'startDate': [item.startDate, Validators.required],
        'endDate': [item.endDate, Validators.required],
        'file': [],
        'recId': [item.recId],
        'recCustomId': [item.recCustomId],
        'filename': [item.filename],
      },
      {validators: [maxDateRange('startDate', 'endDate', 1, 'years')]}
    ));
    const formArray = this.fb.array(holidaysFormGroups, dateRangeOverlap('startDate', 'endDate'));
    this.form.setControl('holidayList', formArray);
  }

  removeHoliday(index) {
    const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Holiday Greeting?',
        text: 'Are you sure you want to delete holiday greeting?',
        actionTitle: 'Delete',
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const holiday = this.holidayFormArray.at(index).value;
        this.holidayFormArray.removeAt(index);

        if (holiday.id) {
          this.onSubmit(true)
        }

      }
    });
  }

  addNewHoliday() {
    this.holidayFormArray.push(this.fb.group({
        'id': '',
        'startDate': [undefined, Validators.required],
        'endDate': [undefined, Validators.required],
        'file': [],
        'recId': [undefined, Validators.required],
        'recCustomId': [],
        'filename': ['', []],
      },
      {validators: [maxDateRange('startDate', 'endDate', 1, 'years')]}
    ));

    this.changeDetectorRef.detectChanges();
  }

  onSubmit(stayInEditPage?: boolean) {
    this.serverError = false;
    this.submitted = false;

    if (this.form.valid && this.hasEditAccess) {
      this.buttonSubmitPromise = this.processSubmit(stayInEditPage);
    } else if (!this.form.valid) {
      const errors = this.getFormErrors(this.form);
      console.error('form not valid', errors);
    }
  }

  getFormErrors(form: UntypedFormGroup): any {
    let errors = [];
    Object.keys(form.controls).forEach(key => {
      const control = form.controls[key];
      if (control instanceof UntypedFormGroup) {
        errors = errors.concat(this.getFormErrors(control));
      }
      if (control instanceof UntypedFormArray) {
        for (let i = 0; i < control.length; i++) {
          const arrControl = control.at(i);
          if (arrControl instanceof UntypedFormGroup) {
            errors = errors.concat(this.getFormErrors(arrControl));
          }

          if (!arrControl.valid && arrControl.errors) {
            errors.push({
              name: key,
              errors: arrControl.errors
            });
          }
        }
      }
      if (!control.valid && control.errors) {
        errors.push({
          name: key,
          errors: control.errors
        });
      }
    });

    return errors;
  }

  async processSubmit(stayInEditPage?: boolean): Promise<void> {
    try {
      this.submitted = true;
      const reqData = this.prepareFormModel();
      await this.pbxService.saveHolidayGreetings(reqData);
      this.notificationService.notifySuccess('Request successfully submitted');
      if(!stayInEditPage) {
        this.headerService.goBack();
      }
    } catch (e) {
      this.serverError = true;
    } finally {
      this.submitted = false;
    }
  }

  prepareFormModel(): HolidayGreetingsModel {
    console.log('prepareFormModel');
    const formModel = this.form.getRawValue();

    const holidayListCopy: HolidayGreetingIvrHolidayModel[] = formModel.holidayList.map(
      (item: HolidayGreetingIvrHolidayModel) => {
        const holidayCopy = Object.assign({}, item);
        if (holidayCopy.file || (holidayCopy.recId !== '-1' && holidayCopy.recId !== '-2')) {
          holidayCopy.recCustomId = '';
        }
        holidayCopy.startDate = DateUtils.localDateToDateTime(new Date(item.startDate)).toISO({includeOffset: false});
        holidayCopy.endDate = DateUtils.localDateToDateTime(new Date(item.endDate)).toISO({includeOffset: false});
        return holidayCopy;
      }
    );

    const files = holidayListCopy.map(x => x.file);

    return {
      account: this.editModel.account,
      accountType: undefined,
      mailboxAccount: formModel.mailboxAccount,
      files: files,
      holidayList: holidayListCopy
    };
  }

  ngOnInit() {
    super.ngOnInit();

    this.isLoading = true;

    this.asyncInit().then(() => {
      console.log('asyncInit completed');
      this.isLoading = false;
    });
  }

  async asyncInit() {
    this.editModel = await this.pbxService.getHolidayGreetingsDetails(this.account);

    this.createForm();
    this.ngOnChanges();

    await this.pbxService.getTextToSpeechVoices();

    // await this.refreshHolidayGreetingsList();

    this.lookupService.lookupGetCustomerExtensions({
      types: ['attendants', 'acds', 'hunts'],
      includeOnlyPrimary: true
    }).toPromise().then((values) => {
      this.availablePbxAccounts = values.data;
    });

    this.lookupService.lookupGetCustomerExtensions({types: ['extensions']}).toPromise().then((values) => {
      const noneMailbox: LookupModel = {
        id: '',
        text: 'No Mailbox',
        isSystem: false
      };
      this.availablePbxExtensions = [noneMailbox, ...values.data];
    });

    this.pbxService.getAvailableHolidayGreetings().then((values) => {
      this.availableHolidayGreetings = [];

      this.availableHolidayGreetings.push({
        id: `hcp${this.editModel.account}55`,
        name: 'Current Holiday Greeting',
        cloudUrl: '',
        fileGroup: 'Current Holiday Greeting',
        fileName: 'Current Holiday Greeting'
      });

      this.availableHolidayGreetings.push(...values);

      this.availableHolidayGreetings.push({
        id: '-1',
        name: 'Custom file',
        cloudUrl: '',
        fileName: '',
        fileGroup: 'Custom file'
      });

      this.availableHolidayGreetings.push({
        id: '-2',
        name: 'Text To Speech',
        cloudUrl: '',
        fileName: '',
        fileGroup: 'Holiday Greetings By Text To Audio'
      });

      this.availableHolidayGreetingsGrouped = _.groupBy(this.availableHolidayGreetings, 'fileGroup');
      console.log('availableHolidayGreetingsGrouped', this.availableHolidayGreetingsGrouped);
    });
  }

  ngOnChanges(changes?: SimpleChanges): void {
    console.log('ngOnChanges');
    this.form.reset({
      mailboxAccount: this.editModel.mailboxAccount || '',
      fileOption: `hcp${this.editModel.account}55`,
    });

    if (!this.editModel.holidayList) {
      this.editModel.holidayList = [];
    }

    this.setHolidayList(this.editModel.holidayList);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.paramsSubscription?.unsubscribe();
    this.headerService.showBackButton(false);
  }

  onPlayRecording(value: any) {
    console.log('onPlayRecording', value);
    if (value.file) {
      this.currentAudioSource = URL.createObjectURL(value.file);
    } else {
      const recId = value.recCustomId || value.recId;
      this.currentAudioSource = `/api/holiday-greetings/pre-audio/stream/${recId}/?t=${new Date().getTime()}`;
    }
    // this.currentAudioDownloadSource = `api/holiday-greetings/audio/download/${recId}`;
  }

  editRecording(formItem: AbstractControl) {
    console.log('editRecording', formItem.value);

    const dialogRef = this.dialog.open(HolidayGreetingsEditRecordingDialogComponent, {
      id: 'holiday-greetings-edit-recording-dialog',
      width: '550px',
      height: '90%',
      data: {
        availableHolidayGreetings: this.availableHolidayGreetings,
        recId: formItem.value.recId,
        availableHolidayGreetingsGrouped: this.availableHolidayGreetingsGrouped
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        console.log(result);

        if (result.recId !== '-1' || result.recId !== '-2') {
          formItem.patchValue({
            recCustomId: '',
          });
        }

        formItem.patchValue({
          recId: result.recId,
          file: result.file,
          filename: result.filename,
        });
      }
    });
  }

  onAudioError(event: any) {
    console.log(event);
    this.notificationService.notifyDanger('Recording file isn\'t available');
  }

  getAccountName() {
    const account = this.availablePbxAccounts.find(x => x.id === this.editModel.account);
    return account ? account.text : '';
  }
}
